module.exports = __webpack_public_path__ + "img/Evaluation Process_Tier 1_Page_7.24b86ff0.jpg";